<div class="flex flex-justify-between-s flex-middle-s flex-wrap">
    <!-- image -->
    @if(!(childMode && client.isS)) {
    <div class="c-1 c-4-s m-b-0 p-r-1 m-r-1-s">
        @if(!childMode) {
        <href class="w-12 ratio-3-4"
              [link]="product.data!.url">
            <img [image]="product.data!.image"
                 class="rf" />
        </href>
        }
    </div>
    }
    <!-- name -->
    <div [class]="getProductInformationClasses()">
        @switch(childMode) {
        @case(true) {
        <div class="b-a p-l-3 p-r-3 p-t-2 p-b-2 inline-block"
             [class]="!product.inStock ? 'is-out-of-stock b-col-6 col-6' : 'b-col-43 col-1'"
             sizeClass="S: p2, !S: p1">
            @for(code of getConfigurableCodes(product.parent); track $index) {
            {{product.data![code] | optionLabel : code}}
            }
        </div>
        @if(client.sizeId > 1 && isBackOrderOnlyUnlessParent) {
        <p class="col-11 p-l-2 p-r-2 bg-col-4 b-a b-col-42 m-t-2-x m-t-2-l center _backorder-label"
           sizeClass="'XL': p2, 'MS': p3">
            {{'Backorder' | translate}}
        </p>
        }
        }
        @default {
        <div class="col-1"
             sizeClass="S: p2 line-clamp-4, !S: p1">{{product.data!.name}}</div>

        <!-- Mobile configurable parent product -->
        @if(isMobileConfigurable) {
        <div class="w-12 inline-flex flex-justify-between">
            <div class="flex flex-column">
                <div class="col-12 p2 c-7 m-b-0">
                    {{product.data!.sku}}
                </div>
                @if(product.isBackorderOnly()){
                <p class="col-11 p-l-2 p-r-2 bg-col-4 b-a b-col-42 m-t-1 center _backorder-label-big"
                   sizeClass="'XL': p2, 'MS': p3">
                    {{'Backorder' | translate}}
                </p>
                }
            </div>
            <div class="right">
                <!-- price -->
                <div class="right col-1 inline-flex flex-justify-end">
                    @if(product.data!.is_from_price) {
                    {{'From' | translate}}:&nbsp;
                    }
                    <price [value]="product.price"
                           [precision]="2"
                           class="col-1 p2"></price>
                </div>

                <!-- total price -->
                <div class="right w-12 col-1 inline-flex flex-justify-end p2 p-t-1">
                    <p>{{'Total' | translate}}:</p>&nbsp;
                    <price [value]="bulk.getRowPrice(product)"
                           [precision]="2"
                           class="p2 col-1 overflow-x-auto overflow-y-hidden"></price>
                </div>
            </div>
        </div>
        }

        @if(!client.isS) {
        @if(product.isConfigurable){
        <button aria-label="Show size"
                type="button"
                (click)="toggle()"
                class="m-t-4 p2 col-11 inline-flex flex-middle">{{'Show' | translate}} {{getExpandLabel()}}
            <i class="icon-plus inline-flex"
               [toggleClass]="'!icon-plus icon-minus'"
               [toggleClassBy]="childrenOpen$">
            </i></button>
        }
        @if(product.isBackorderOnly()) {
        <p class="col-11 p-l-2 p-r-2 bg-col-4 b-a b-col-42 m-t-1 center _backorder-label"
           sizeClass="'XL': p2, 'MS': p3">
            {{'Backorder' | translate}}
        </p>
        }
        }
        }
        }
        <!-- sku mobile -->
        @if(client.isS && !product.isConfigurable && !childMode) {
        <div class="col-12 p2">
            {{product.data!.sku}}
        </div>
        }
    </div>
    <!-- sku -->
    @if(client.sizeId > 0 || childMode) {
    <div
         class="c-2 c-6-s p-l-5 p-l-0-s m-r-0-s m-b-0 col-12 p2 center-s break-words flex-s flex-middle-s flex-column-s">
        {{product.data!.sku}}
        @if(client.sizeId === 0){
        <ng-container *ngTemplateOutlet="backOrdersLabel"></ng-container>
        }
    </div>
    }

    @if(client.sizeId > 0) {
    <!-- qty -->
    <div class="c-3 c-2-m m-b-0">
        @if(!hideParentQty){
        <item-qty class="block col-1"
                  [model]="bulk.getQty(product)"
                  [min]="0"
                  [max]="product.isConfigurable ? undefined : 10000"
                  [isDisabled]="product.isConfigurable || (!product.inStock && !bulk.getQty(product))"
                  [isParent]="isParent"
                  [product]="product"
                  (qtyChange)="bulk.setQty(product, +$event)">
        </item-qty>
        }
        <ng-container *ngTemplateOutlet="backOrdersLabel"></ng-container>
        <div class="pos-relative">
            <div class="m-t-2 pos-absolute col-2 fs-4">
                {{ bulk.getError(product)}}
            </div>
        </div>
    </div>
    <!-- price -->
    <div class="c-2 m-b-0 tail-cols">
        @if(product.data!.is_from_price){
        <span class="p2 col-11">{{'From' | translate}}</span>:&nbsp;
        }
        <price [value]="product.price"
               [precision]="2"
               class="p2 col-1"></price>
    </div>
    <!-- total price -->
    <div class="c-1 m-b-0 m-r-0 right tail-cols"
         style="word-break:break-all">
        <price [value]="bulk.getRowPrice(product)"
               [precision]="2"
               [class.fw-bold]="isParent"
               class="p2 col-1"></price>
    </div>
    }

    @if(client.isS && !product.isConfigurable) {
    <div class="w-3 flex-column flex-justify-between flex-bottom right">

        <!-- qty -->
        <div class="p1"
             [class.m-t-1]="childMode">
            <item-qty class="block col-1 p1"
                      [model]="bulk.getQty(product)"
                      [product]="product"
                      [min]="0"
                      [max]="product.isConfigurable ? undefined : 10000"
                      [isDisabled]="product.isConfigurable || !product.inStock"
                      [bigVariant]="true"
                      (qtyChange)="bulk.setQty(product, +$event)">
            </item-qty>
        </div>

        <!-- price -->
        <div class="p2">
            @if(product.data!.is_from_price){
            <span class="col-11">{{'From' | translate}}</span>:&nbsp;
            <price [value]="product.price"
                   [precision]="2"
                   class="p2 col-1"></price>
            }
        </div>

        <!-- total price -->
        @if(!childMode) {
        <div class="right col-1 inline-flex flex-justify-end p2">
            <p>{{'Total' | translate}}</p>:&nbsp;
            <price [value]="bulk.getRowPrice(product)"
                   [precision]="2"
                   class="p2 col-1"></price>
        </div>
        }
    </div>
    }
</div>

<!-- error mobile -->
@if(client.isS) {
<div class="m-t-2 col-2 p2 right">
    {{ bulk.getError(product)}}
</div>
}

<!-- result -->
@if(children.length) {
<div [hideUp]="childrenOpen$">
    @for(child of children; track $index) {
    <bulk-order-listing-product [product]="child"
                                class="p-t-5 p-b-8 p-t-2-s p-b-2-s block"
                                [childMode]="true"
                                [bulk]="bulk"></bulk-order-listing-product>
    }
</div>
}

@if(product.isConfigurable && client.isS) {
<button aria-label="Show size"
        type="button"
        (click)="toggle()"
        class="m-t-2 w-12 p2">
    <span class="p-a w-12 col-1 bg-col-5 inline-flex flex-justify-between">
        <span>
            <span [toggleClass]="'!ng-hide'"
                  [toggleClassBy]="childrenOpen$">{{'Hide' | translate}}</span>
            <span [toggleClass]="'ng-hide'"
                  [toggleClassBy]="childrenOpen$">{{'Show' | translate}}</span>
            {{getExpandLabel()}}</span>
        <i class="icon-plus inline-flex"
           [toggleClass]="'!icon-plus icon-minus'"
           [toggleClassBy]="childrenOpen$">
        </i>
    </span>
</button>
}


<ng-template #backOrdersLabel>
    @if(product.inStockEstimationMessage && product.isBackorderOnly() && !product.isConfigurable){
    <p class="w-8-s col-11 p-l-2 p-r-2 bg-col-4 b-a b-col-42 m-t-1 center _estimated-in-stock-label"
       [ngClass]="isBackOrderOnlyUnlessParent ? 'm-t-3-x m-t-3-l' : ''"
       sizeClass="'XL': p2, 'MS': p3">
        {{'Estimated in stock' | translate}} {{product.inStockEstimationMessage}}
    </p>
    }
</ng-template>